import {
    Dialog,
    DialogActions,
    DialogContent, DialogTitle, Step, StepLabel, Stepper,
} from "@mui/material";
import ButtonAdd from "../../../button/ButtonAdd";
import ButtonExit from "../../../button/ButtonExit";
import React, {useEffect, useState} from "react";
import JobMetricOrganizationTable from "./JobMetricOrganizationTable";
import JobMetricOrganizationService from "../../../../../API/orders/job/JobMetricOrganizationService";
import Box from "@mui/material/Box";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";
import {orderJobType} from "../../../../../data/OrderJobType";
import MenuItem from "@mui/material/MenuItem";
import JobMetricAdminPackingService from "../../../../../API/orders/job/Admin/JobMetricAdminPackingService";
import JobMetricAdminMillingService from "../../../../../API/orders/job/Admin/JobMetricAdminMillingService";
import JobMetricAdminEdgeService from "../../../../../API/orders/job/Admin/JobMetricAdminEdgeService";
import JobMetricAdminDrillingService from "../../../../../API/orders/job/Admin/JobMetricAdminDrillingService";
import JobMetricAdminCuttingService from "../../../../../API/orders/job/Admin/JobMetricAdminCuttingService";
import ButtonBack from "../../../button/ButtonBack";
import {useLocation} from "react-router-dom";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import {JobMetricOrganizationFilterData} from "../../../../../data/FilterTables/JobMetricOrganizationFilterData";

const ModalAddJob = ({
                         open, onClose, onSubmit, handleModalAlert, materialOrganizationOptionId, baseCurrency,
                         alternativeCurrency, group, deleteJob, admin, type, itemId,
                         loading
                     }) => {
    const pathname = useLocation().pathname
    const [activeStep, setActiveStep] = useState(0)
    const [jobMetric, setJobMetric] = useState([])
    const [rowSelection, setRowSelection] = useState([])
    const allOrderJobTypes = Object.entries(orderJobType)
    const [formState, setFormState] = useState({currJob: allOrderJobTypes[0][0]})
    const [filteredData, setFilteredData] = useState([])
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: jobMetric?.length,
        searchData: ""
    })
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, JobMetricOrganizationFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [JobMetricOrganizationFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`${pathname}-modal`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}-modal`]?.pageSize
        const searchQuery = pagesData[`${pathname}-modal`]?.searchQuery

        return {searchQuery, pageSize}
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const service = (type || formState.currJob) === "PACKAGING" ? JobMetricAdminPackingService :
        (type || formState.currJob) === "MILLING" ? JobMetricAdminMillingService
            : (type || formState.currJob) === "EDGE" ? JobMetricAdminEdgeService
                : (type || formState.currJob) === "DRILLING" ? JobMetricAdminDrillingService
                    : (type || formState.currJob) === "CUT" ? JobMetricAdminCuttingService
                        : JobMetricOrganizationService

    const handleSubmit = () => {
        if (activeStep === 0) {
            setActiveStep(1)
            const api = group ? service.get() : service.getForAddMaterial(materialOrganizationOptionId)
            api.then(function (response) {
                setJobMetric(response.data)
                handleSearchQuery(globalFilter, response?.data)
            }).catch(function (error) {
                handleModalAlert(error)
            })
        } else {
            const addedData = jobMetric.filter(el => rowSelection.includes(el.id))
            onSubmit(rowSelection, addedData, formState.currJob)
        }

    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        if (type) {
            setActiveStep(1)
            open && service.getForAddMaterial(materialOrganizationOptionId).then(function (response) {
                setJobMetric(response.data)
                handleSearchQuery(searchQuery, response.data, pageSize)
                setTypeList(OrderUtil.getListFieldByEnum(response.data, 'orderJobType', orderJobType));
            }).catch(function (error) {
                handleModalAlert(error)
            })
        } else if (!admin) {
            setActiveStep(1)
            const api = group ? JobMetricOrganizationService.get() : JobMetricOrganizationService.getAllForAddMaterialOrganizationOptionId(materialOrganizationOptionId)
            open && api.then(function (response) {
                setJobMetric(response.data)
                handleSearchQuery(searchQuery, response.data, pageSize)
                setTypeList(OrderUtil.getListFieldByEnum(response.data, 'orderJobType', orderJobType));
            }).catch(function (error) {
                handleModalAlert(error)
            })
        }
    }, [open, type]);

    const handleClose = () => {
        onClose()
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: activeStep === 0 ? "400px" : admin ? "1700px" : "1585px",
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: "16px 24px",
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    margin: "auto",
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{deleteJob ? "Удалить работы" : "Добавить работы"}</DialogTitle>
                {admin && <Stepper
                    alternativeLabel
                    style={{width: "600px"}}
                    activeStep={activeStep}>
                    {["Тип работ", "Работы"].map((label) => (
                        <Step key={label} sx={{
                            "& .MuiStepConnector-root": {
                                top: "20px",
                                left: 'calc(-50% + 30px)',
                                right: "calc(50% + 30px)"
                            }
                        }}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                },

                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent>
                {activeStep === 0
                    ?
                    <TextFieldValidation
                        select
                        name="currJob"
                        label="Тип работ"
                        value={formState.currJob}
                        setCurrValues={setFormState}
                    >
                        {allOrderJobTypes.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                    : <JobMetricOrganizationTable
                        data={jobMetric}
                        isModal={true}
                        rowSelection={rowSelection}
                        setRowSelection={setRowSelection}
                        enableRowSelection={true}
                        baseCurrency={baseCurrency}
                        alternativeCurrency={alternativeCurrency}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        columnAdded={false}
                        handleModalAlert={handleModalAlert}
                        admin={admin}
                        itemId={itemId || ((admin && formState.currJob === "EDGE") && "listJobEdge")}
                        globalFilter={globalFilter}
                        handleSearchQuery={handleSearchQuery}
                        filteredData={filteredData}
                        columnsFilter={columnsFilter}
                        typeList={typeList}
                    />}
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep === 1 && admin &&
                    <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Отменить"} onClick={handleClose}/>
                    <ButtonAdd loading={loading} text={"Выбрать"} onClick={handleSubmit}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default ModalAddJob